<template>
  <Control :title="title" :isEdit="isEdit && enabled" :validator="validator" :height="36 + (isEdit&&enabled?rows - 1:0 ) * 25" :provider="editor ? editor.owner:null"  :isDirectEditEnabled="isDirectEditEnabled"   :editor="editor"  :enabled="enabled" :tooltip="tooltip"  :key="title">
    <template slot="read">{{selectedText}}</template>
    <template slot="edit">
      <b-form-radio-group v-model="selected" size="sm" class="cx_radio">
        <b-form-radio :value="option.value" v-for="option in options" :key="option.value" :disabled="(option.value & disabled) > 0">{{option.text}}</b-form-radio>
      </b-form-radio-group>
    </template>
  </Control>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class RadioButton extends Vue  implements Components.IControl {

  @Prop({default:''}) public title?: string;
  @Prop({default:null}) public value?: any;
  @Prop({default:''}) public list?: string;
  @Prop() public tooltip: string;
  @Prop({default:null}) public editor :Components.IEditor;
  @Prop({default:true}) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;    
  @Prop({ default: 1 }) public rows: number;
  @Prop({ default: 0 }) public disabled: number;  //特定の値を非活性表示
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null ;

  created(){
    this.validator = new Components.ControlValidator(this, 'tooltip', ()=>'');    
    if (this.editor != null) this.editor.addControl(this);
  }
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }

  public get selected(): any {
    return this.value;
  }

  public set selected(value: any) {
    // 親コンポーネント側で更新
    this.$emit('update:value', value);
  }

  public get selectedText(): string {
    for (const option of this.$api.formatter.getOptions(this.list)) {
      if (option.value === this.value) {
        return option.text;
      }
    }
    return '';
  }

  public get options(): any {
    const results: any[] = new Array();
    for (const option of this.$api.formatter.getOptions(this.list)) {
      results.push({ text: option.text, value: option.value });
    }
    return results;
  }
}
</script>
<style lang="scss">
.cx_radio{
  display:flex;
  align-items: center;
  .cx_spmode & {
    overflow-x:auto;
    align-items: flex-start;
    height:34px;
  }
  .custom-radio {
    padding-right: 0px !important; //横幅が広すぎるので調整
    margin-right :12px;    
  }
  .custom-control-label::before,
  .custom-control-label::after  
  {
    top:2px;
    left:-1.4rem;
  }
  input {
    position: relative;
  }
  label{
    white-space: nowrap;
  }
}
</style>
